import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import environment from '@environments/environment';
import {
  DocumentDownloadResponse,
  DownloadRequest,
  ExportRequest,
  DocumentExportResponse,
  DocumentLinkResponse,
  DocumentDownload,
  DocumentExport,
} from '../types';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class DownloadsExportsService {
  private readonly _http = inject(HttpClient);
  private readonly _wcgTableUtils = inject(WcgTableUtilsService);

  downloadDocumentBundle(downloadRequest: DownloadRequest) {
    return this._http.post<DocumentDownload>(
      `${environment.irisApi}/v2/document/bundle/`,
      downloadRequest,
    );
  }
  exportDocumentBundle(exportRequest: ExportRequest) {
    const { url, wcgTableValues, args } = exportRequest;
    let queryParams =
      this._wcgTableUtils.generateTableQueryParams(wcgTableValues);
    if (args) {
      for (const [key, value] of Object.entries(args)) {
        if (value !== undefined) {
          queryParams = queryParams.append(key, String(value));
        }
      }
    }
    return this._http.get<DocumentExport>(url, { params: queryParams });
  }
  getDocumentDownloads(params: {
    category: string;
  }): Observable<DocumentDownloadResponse> {
    return this._http.get<DocumentDownloadResponse>(
      `${environment.irisApi}/resources/`,
      { params },
    );
  }
  getDocumentLink(id: string) {
    return this._http.get<DocumentLinkResponse>(
      `${environment.irisApi}/resource/${id}/`,
    );
  }

  getDocumentExports(params: {
    category: string;
  }): Observable<DocumentExportResponse> {
    return this._http.get<DocumentExportResponse>(
      `${environment.irisApi}/resources/`,
      { params },
    );
  }
}
